import * as lan from '../common/script/common_lan.js';

import React, {useState, useEffect} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import * as common from '../common/script/common';
import $ from 'jquery';

import BottomCountry from '../popup/bottom_country';
import * as slide from '../popup/bottom_country';

const maxbirthnum = 8;
const maxbirthyearnum = 4;
const maxbirthmonthnum = 2;
const maxbirthdaynum = 2;

export default function Addition(){
	
	const location = useLocation();
	const navigate = useNavigate();
	const [InfoData, SetInfoData] = useState({});
	const isEnglish = sessionStorage.getItem('Language') == 'en';

	//화면전환시 실행
	useEffect(() => {
		if(window.localStorage.getItem('join_gender') === null) window.localStorage.setItem('join_gender','');
		if(window.localStorage.getItem('join_birthday') === null) window.localStorage.setItem('join_birthday','');
		if(window.localStorage.getItem('join_countryValue') === null) window.localStorage.setItem('join_countryValue','');
		if(window.localStorage.getItem('join_country') === null) window.localStorage.setItem('join_country','');
		if(window.localStorage.getItem('join_birthday') != '') {}

		var nowlen = sessionStorage.getItem('Language');
		var storedBirthday = window.localStorage.getItem('join_birthday');
		var storedBirthdayNumber = storedBirthday == null ? '' : storedBirthday.replace(/-/g,'');
		var storedCountryValue = window.localStorage.getItem('join_countryValue');
		var storedCountry = window.localStorage.getItem('join_country');
		var countryValue = storedCountryValue == '' ? common.commonKeyDic[nowlen]['countryValue'] : storedCountryValue;
		var country = storedCountry == '' ? common.commonKeyDic[nowlen]['country'] : storedCountry;

		SetInfoData(
			{
			  gender : window.localStorage.getItem('join_gender') == '' ? '0' : window.localStorage.getItem('join_gender'),
			  birthday : storedBirthdayNumber,
			  birthYear : storedBirthdayNumber.substr(0,4),
			  birthMonth : storedBirthdayNumber.substr(4,2),
			  birthDay : storedBirthdayNumber.substr(6,2),
			  countryValue : countryValue,
			  country : country
			}
		);
		$("input[name=gender][value=" + (window.localStorage.getItem('join_gender') == '' ? '0' : window.localStorage.getItem('join_gender')) + "]").prop('checked',true);
		$("#newCountryValue").val(countryValue);
		$("#newCountry").html(country);
		checkAllPossible(storedBirthdayNumber);
    },[location]);

	const onChange = (e) => {
		  var id = e.target.id;
		  var value = e.target.value.replace(/[^0-9]/g, '');
		  var data = {...InfoData};

		if(id == "newbirthday")
		{
			value = value.slice(0, maxbirthnum);
			e.target.value = value;
			data.birthday = value;
			SetInfoData(data);
			checkAllPossible(value);
		}
		else if(id == "newBirthYear" || id == "newBirthMonth" || id == "newBirthDay")
		{
			if(id == "newBirthYear") value = value.slice(0, maxbirthyearnum);
			else value = value.slice(0, maxbirthmonthnum);
			e.target.value = value;

			data.birthYear = $("#newBirthYear").val();
			data.birthMonth = $("#newBirthMonth").val();
			data.birthDay = $("#newBirthDay").val();
			data.birthday = data.birthYear + data.birthMonth + data.birthDay;
			SetInfoData(data);
			checkAllPossible(data.birthday);
		}
	}

	// 버튼
	const goPhonenumber = (e) => {
		InfoData.gender = $("input[name=gender]:checked").val();
		InfoData.birthday = isEnglish ? $("#newBirthYear").val() + $("#newBirthMonth").val() + $("#newBirthDay").val() : $("#newbirthday").val();
		InfoData.country = $("#newCountry").html();
		InfoData.countryValue = $("#newCountryValue").val();

		window.localStorage.setItem('join_gender',InfoData.gender);
		window.localStorage.setItem('join_birthday',common.getStringToDate(InfoData.birthday,'-'));
		window.localStorage.setItem('join_countryValue',InfoData.countryValue);
		window.localStorage.setItem('join_country',InfoData.country);

		//console.log(InfoData);
		navigate('/join/phonenumber',{replace:true});
	}

	return (
	<>
	<BottomCountry returntype="html" returnid="newCountry" returnvalueid="newCountryValue"></BottomCountry>
	<div>
	  <div className="container">
		<div className="process">
		  <span><b>4</b>/5</span>
		  <em>{lan.L('추가정보입력')}</em>
		</div>
		<ul className="write_form">
		  <li>
			<span>
			  <div className="selection_tab">
				<a>
				  <input type="radio" id="male" name="gender" value="0" defaultChecked />
				  <label htmlFor="male">{lan.L('남성')}</label>
				</a>
				<a>
				  <input type="radio" id="female" name="gender" value="1" />
				  <label htmlFor="female">{lan.L('여성')}</label>
				</a>
			  </div>
			  <em>{lan.L('성별')}</em>
			</span>
		  </li>
		  <li>
			{isEnglish ?
			  <div className="birth_split">
				<em>{lan.L('생년월일')}</em>
				<div>
				  <span>
					<input type="text" inputMode="numeric" maxLength={maxbirthyearnum} id="newBirthYear" placeholder="1980" value={InfoData.birthYear === undefined ? '' : InfoData.birthYear} onChange={onChange}/>
					<label htmlFor="newBirthYear">YY</label>
				  </span>
				  <span>
					<input type="text" inputMode="numeric" maxLength={maxbirthmonthnum} id="newBirthMonth" placeholder="01" value={InfoData.birthMonth === undefined ? '' : InfoData.birthMonth} onChange={onChange}/>
					<label htmlFor="newBirthMonth">MM</label>
				  </span>
				  <span>
					<input type="text" inputMode="numeric" maxLength={maxbirthdaynum} id="newBirthDay" placeholder="20" value={InfoData.birthDay === undefined ? '' : InfoData.birthDay} onChange={onChange}/>
					<label htmlFor="newBirthDay">DD</label>
				  </span>
				</div>
			  </div>
			  :
			  <span>
				<input type="text" inputMode="numeric" maxLength={maxbirthnum} id="newbirthday"  placeholder="ex) 19800101" value={InfoData.birthday === undefined ? '' : InfoData.birthday} onChange={onChange}/>
				<em>{lan.L('생년월일')}</em>
			  </span>
			}
		  </li>
		  <li>
			<span>
			  <input type="hidden" id="newCountryValue" defaultValue={InfoData.countryValue === undefined ? '' : InfoData.countryValue}/>
			  <label onClick={(e) => slide.slideOn()} id="newCountry">{InfoData.country === undefined ? '' : InfoData.country}</label>
			  <em>{lan.L('국가')}</em>
			</span>
		  </li>
		</ul>
	  </div>
	  <div className="sticky_button">
		<button type="button" className="btn_standard" id="btnPhonenumber" onClick={goPhonenumber}>{lan.L('다음')}</button>
	  </div>
	</div>
	</>
	)
}

function checkAllPossible(birthday){
	if(birthday.length != maxbirthnum)
	{
		$("#btnPhonenumber").attr('disabled',true);
		return false;
	}

	if(birthday.slice(0, 4) > new Date().getFullYear() || birthday.slice(4, 6) > 12 || birthday.slice(6, 8) > 31)
	{
		$("#btnPhonenumber").attr('disabled',true);
		return false;
	}

	$("#btnPhonenumber").attr('disabled',false);
}
